import React from 'react';
import styles from './componenteNCM.module.scss';
import ListaNCM from './components/listaNCM/listaNCM';
import { BrButton, BrDivider, BrLoading } from '@govbr-ds/react-components';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';
import FormNCMReceitaBruta from '../componentesBaseCalculo/components/receitaBruta/components/formNCMReceitaBruta/formNCMReceitaBruta';
import { IReceitaBrutaNCMReceber } from '../../../../../../../interfaces/IReceitaBruta';
import FormNCMVendaNacional from '../componentesBaseCalculo/components/vendaNacional/components/formNCMVendaNacional/formNCMVendaNacional';
import { ETipoOperacao } from '../../../../../../../enums/ETipoOperacao';
import FormNCMReceitaBrutaCalculada from '../componentesBaseCalculo/components/receitaBrutaCalculada/components/formNCMReceitaBrutaCalculada/formNCMReceitaBrutaCalculada';
import { IVendaNacionalNCMReceber } from '../../../../../../../interfaces/IVendaNacional';
import { INCMReceitaBrutaCalculada } from '../../../../../../../interfaces/IReceitaBrutaCalculada';
import FormNCMReceitaExportacoes from '../componentesBaseCalculo/components/receitaExportacoes/components/formNCMReceitaExportacoes/formNCMReceitaExportacoes';
import {
  IReceitaExportacoesNCM,
  IReceitaExportacoesVinculadaNCM,
} from '../../../../../../../interfaces/IReceitaExportacoes';
import { useNotificacao } from '../../../../../../../hooks/useNotificacao';

interface IComponenteNCMProps {
  isEdicaoNcm: boolean;
  setIsEdicaoNcm?: React.Dispatch<React.SetStateAction<boolean>>;
  isReadOnly?: boolean;
  ncmListaData:
    | IReceitaBrutaNCMReceber[]
    | IVendaNacionalNCMReceber[]
    | INCMReceitaBrutaCalculada[]
    | (IReceitaExportacoesNCM | IReceitaExportacoesVinculadaNCM)[]
    | undefined;
  refetchDadosAnteriores?: () => void;
  isListaNCMLoading?: boolean;
  listaNCMError?: IErrorWithSentryId | null;
  refetchListaNCM?: () => void;
  type: ETipoOperacao;
  insideTitle?: boolean;
}

const ComponenteNCM = ({
  isEdicaoNcm,
  setIsEdicaoNcm,
  isReadOnly = false,
  ncmListaData,
  refetchDadosAnteriores,
  isListaNCMLoading,
  listaNCMError,
  refetchListaNCM,
  type,
  insideTitle = false,
}: IComponenteNCMProps) => {
  const mostrarNotificacao = useNotificacao();

  const ncmAdicionado = () => {
    if (isEdicaoNcm) {
      mostrarNotificacao({
        tipo: 'success',
        conteudo: 'NCM editado com sucesso!',
      });
    } else {
      mostrarNotificacao({
        tipo: 'success',
        conteudo: 'NCM adicionado com sucesso!',
      });
    }

    if (refetchListaNCM) {
      refetchListaNCM();
    }
  };
  const formContent = () => {
    if (type === ETipoOperacao.RECEITA_BRUTA_TRIBUTOS_INCIDENTES) {
      return (
        <FormNCMReceitaBruta
          refetchListaNCM={ncmAdicionado}
          isEdicaoNcm={isEdicaoNcm}
          setIsEdicaoNcm={setIsEdicaoNcm}
          refetchDadosAnteriores={refetchDadosAnteriores}
        />
      );
    } else if (type === ETipoOperacao.VENDA_TERRITORIO_NACIONAL_EMPRESAS_COLIGADAS_OU_MESMO_GRUPO_ECONOMICO) {
      return (
        <FormNCMVendaNacional
          refetchListaNCM={ncmAdicionado}
          isEdicaoNcm={isEdicaoNcm}
          setIsEdicaoNcm={setIsEdicaoNcm}
          refetchDadosAnteriores={refetchDadosAnteriores}
        />
      );
    } else if (type === ETipoOperacao.RECEITA_CALCULADA_EXPORTACOES) {
      return (
        <FormNCMReceitaExportacoes
          refetchListaNCM={ncmAdicionado}
          isEdicaoNcm={isEdicaoNcm}
          setIsEdicaoNcm={setIsEdicaoNcm}
          refetchDadosAnteriores={refetchDadosAnteriores}
        />
      );
    } else if (type === ETipoOperacao.RECEITA_BRUTA_CALCULADA) {
      return (
        <FormNCMReceitaBrutaCalculada
          refetchListaNCM={ncmAdicionado}
          isEdicaoNcm={isEdicaoNcm}
          setIsEdicaoNcm={setIsEdicaoNcm}
        />
      );
    }
  };
  return (
    <div className={styles.container}>
      {!isReadOnly && !insideTitle && (
        <div className={styles.formTitle}>
          <span>Códigos NCM</span>
        </div>
      )}
      <div className={styles.contentContainer}>
        {!isReadOnly && insideTitle && (
          <div className={styles.insideTitle}>
            <span>Códigos NCM</span>
          </div>
        )}
        {!isReadOnly && formContent()}
        {!isReadOnly && <BrDivider className={styles.dividerSpacing} />}
        {!isEdicaoNcm && (
          <>
            {isListaNCMLoading ? (
              <BrLoading />
            ) : (
              <ListaNCM
                isReadOnly={isReadOnly}
                listaNCMData={ncmListaData}
                refetchListaNCM={refetchListaNCM ?? (() => {})}
                setIsEdicaoNcm={setIsEdicaoNcm}
                refetchDadosAnteriores={refetchDadosAnteriores}
                type={type}
              />
            )}
            {listaNCMError && (
              <>
                <span className={styles.errorText}>Não foi possível atualizar a lista de NCM</span>
                <br />
                <BrButton
                  size='small'
                  onClick={() => {
                    if (refetchListaNCM) refetchListaNCM();
                  }}
                >
                  (Tentar novamente)
                </BrButton>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ComponenteNCM;
